import https from "./fetch";
var http = https.http;
var default_1 = /** @class */ (function () {
    function default_1() {
    }
    default_1.prototype.listIntelligentExp = function (data) {
        return http.post("./api/intelligentExp/listIntelligentExp", data);
    };
    /**
     * 创建新模块案例
     * @param data FormData
     */
    default_1.prototype.mergeIntelligentExp = function (data) {
        return http.post("./api/intelligentExp/mergeIntelligentExp", data);
    };
    /**
     *
     * @param data 查询案例基本信息id
     */
    default_1.prototype.queryIntelligentExp = function (data) {
        return http.post("./api/intelligentExp/queryIntelligentExp", data);
    };
    /**
     *
     * @param data 创建自定义案例背景信息
     */
    default_1.prototype.mergeIntelligentBackgroundInfo = function (data) {
        return http.post("./api/intelligentExp/mergeIntelligentBackgroundInfo", data);
    };
    /**
     *
     * @param data 添加自定义案例背景信息图片
     */
    default_1.prototype.mergeIntelligentBackgroundInfoPath = function (data) {
        return http.post("./api/intelligentExp/mergeIntelligentBackgroundInfoPath", data);
    };
    /**
     *
     * @param data 添加自定义案例阶段说明图片
     */
    default_1.prototype.mergeIntelligentExecuteIntroducePath = function (data) {
        return http.post("./api/intelligentExp/mergeIntelligentExecuteIntroducePath", data);
    };
    /**
     *
     * @param data 创建自定义案例阶段说明
     */
    default_1.prototype.mergeIntelligentExecuteIntroduce = function (data) {
        return http.post("./api/intelligentExp/mergeIntelligentExecuteIntroduce", data);
    };
    /**
     *
     * @param data 添加措施设置上传图片
     */
    default_1.prototype.uploadMeasureSetImage = function (data) {
        return http.post("./api/measureType/uploadMeasureSetImage", data);
    };
    /**
     *
     * @param data 查询自定义案例阶段说明
     */
    default_1.prototype.queryIntelligentExecuteIntroduce = function (data) {
        return http.post("./api/intelligentExp/queryIntelligentExecuteIntroduce", data);
    };
    /**
     *
     * @param data 查询用户信息
     */
    default_1.prototype.userInfo = function (data) {
        return http.post("./api/user/getByCode", data);
    };
    /**
     *
     * @param data 查询用户所在班级
     */
    default_1.prototype.querystudentclass = function (data) {
        // 查询学生所在班级
        return http.post("./api/class/getClassRoomByUserCode", data);
    };
    /**
     *
     * @param data 查询通知信息
     */
    default_1.prototype.listWithoutNotification = function (data) {
        return http.post("./notification/listWithoutNotification", data);
    };
    /**
     *
     * @param data 查询案例背景信息
     */
    default_1.prototype.queryIntelligentBackgroundInfo = function (data) {
        return http.post("./api/intelligentExp/queryIntelligentBackgroundInfo", data);
    };
    /**
     *
     * @param data 创建修改地区设置
     */
    default_1.prototype.mergeMapSystem = function (data) {
        return http.post("./api/mapSystem/mergeMapSystem", data);
    };
    /**
     *
     * @param data 查询地区设置地区设置
     */
    default_1.prototype.queryMapSystem = function (data) {
        return http.post("./api/mapSystem/queryMapSystem", data);
    };
    /**
     *
     * @param data 删除地图系统中的部门
     */
    default_1.prototype.delMapDepartment = function (data) {
        return http.post("./api/mapSystem/delMapDepartment", data);
    };
    /**
     *
     * @param data 更改地区部门图片
     */
    default_1.prototype.updateMapDepartmentPath = function (data) {
        return http.post("./api/mapSystem/updateMapDepartmentPath", data);
    };
    /**
     *
     * @param data 删除所有个人用户通知
     */
    default_1.prototype.deleteAllNotification = function () {
        return http.post("./notification/deleteAllNotification");
    };
    /**
     *
     * @param data 教师分配案例日志
     */
    default_1.prototype.queryExperiment = function (data) {
        return http.post("./api/experiment/queryExperiment", data);
    };
    /**
     *
     * @param data 报告管理 一级页面 下载详情
     */
    default_1.prototype.exportScore = function (data) {
        return http.post("./api/exportExcel/exportScore", data);
    };
    /**
     *
     * @param data 报告管理 教师结束实训
     */
    default_1.prototype.finishExperiment = function (data) {
        return http.post("./api/experiment/finishExperiment", data);
    };
    /**
     *
     * @param data 上传文件
     */
    default_1.prototype.uploadFile = function (data) {
        return http.post("./api/textUploadFile/uploadFile", data);
    };
    /**
     *
     * @param data 添加自定义案例基本信息公共政策
     */
    default_1.prototype.mergeCommonalityPolicy = function (data) {
        return http.post("./api/intelligentExp/mergeCommonalityPolicy", data);
    };
    /**
     *
     * @param data 查询公共政策
     */
    default_1.prototype.queryCommonalityPolicy = function (data) {
        return http.post("./api/intelligentExp/queryCommonalityPolicy", data);
    };
    /**
     *
     * @param data 批量创建/修改措施类别
     */
    default_1.prototype.mergeMeasureType = function (data) {
        return http.post("./api/measureType/mergeMeasureType", data);
    };
    /**
     *
     * @param data 查询措施设置类别
     */
    default_1.prototype.queryMeasureType = function (data) {
        return http.post("./api/measureType/queryMeasureType", data);
    };
    /**
     *
     * @param data 删除措施类别
     */
    default_1.prototype.delMeasureType = function (data) {
        return http.post("./api/measureType/delMeasureType", data);
    };
    /**
     *
     * @param data 查询班级下学生
     */
    default_1.prototype.listClassMemberRequest = function (data) {
        return http.post("./classMember/listClassMemberRequest", data);
    };
    /**
     *
     * @param data 二季页面 下载PDF报告
     */
    default_1.prototype.exportExperimentReport = function (data) {
        return http.post("./api/exportExperimentReport/exportExperimentReport", data);
    };
    /**
     *
     * @param data 二级页面 批量导出报告 zip包
     */
    default_1.prototype.exportReportToZIp = function (data) {
        return http.post("./api/exportExperimentReport/exportReportToZIp", data);
    };
    /**
     *
     * @param data 报告管理 二级页面 删除和批量删除
     */
    default_1.prototype.deleteExperimentMeber = function (data) {
        return http.post("./api/experimentMember/deleteExperimentMeber", data);
    };
    /**
     *
     * @param data 报告管理 二级页面 查看实训下所有学生的实训
     */
    default_1.prototype.showExperimentMeber = function (data) {
        return http.post("./api/experimentMember/showExperimentMeber", data);
    };
    /**
     *
     * @param data 批量修改措施设置
     */
    default_1.prototype.batchUpdateMeasureSet = function (data) {
        return http.post("./api/measureType/batchUpdateMeasureSet", data);
    };
    /**
     *
     * @param data 查询措施设置
     */
    default_1.prototype.queryListMeasureSet = function (data) {
        return http.post("./api/measureType/queryListMeasureSet", data);
    };
    /**
     *
     * @param data 删除措施设置
     */
    default_1.prototype.delMeasureSet = function (data) {
        return http.post("./api/measureType/delMeasureSet", data);
    };
    /**
     *
     * @param data 查询案例下全部措施
     */
    default_1.prototype.batchQueryMeasureSet = function (data) {
        return http.post("./api/measureType/batchQueryMeasureSet", data);
    };
    /**
     *
     * @param data 查询措施下的指标公式
     */
    default_1.prototype.queryIndexChangeList = function (data) {
        return http.post("./api/variableFormula/queryIndexChangeList", data);
    };
    /**
     *
     * @param data 批量创建修改核心指标
     */
    default_1.prototype.batchMergeKernelIndex = function (data) {
        return http.post("./api/indexSystem/batchMergeKernelIndex", data);
    };
    /**
      *
      * @param data 查询核心指标
      */
    default_1.prototype.queryKernelIndex = function (data) {
        return http.post("./api/indexSystem/queryKernelIndex", data);
    };
    /**
      *
      * @param data 批量创建修改执行指标
      */
    default_1.prototype.batchMergeExecuteIndex = function (data) {
        return http.post("./api/indexSystem/batchMergeExecuteIndex", data);
    };
    /**
      *
      * @param data 查询执行指标
      */
    default_1.prototype.queryExecuteIndex = function (data) {
        return http.post("./api/indexSystem/queryExecuteIndex", data);
    };
    /**
      *
      * @param data 删除执行指标
      */
    default_1.prototype.delExecuteIndex = function (data) {
        return http.post("./api/indexSystem/delExecuteIndex", data);
    };
    /**
     *
     * @param data 删除 操作性时间-选项下关联数据
     */
    default_1.prototype.delOperatingOptionData = function (data) {
        return http.post("./api/measureTrigger/delOperatingOptionData", data);
    };
    /**
    *
    * @param data 删除 操作性时间-选项
    */
    default_1.prototype.delOperatingOption = function (data) {
        return http.post("./api/measureTrigger/delOperatingOption", data);
    };
    /**
    *
    * @param data 删除 操作性时间-
    */
    default_1.prototype.delIndexInfluence = function (data) {
        return http.post("./api/measureTrigger/delIndexInfluence", data);
    };
    /**
      *
      * @param data 查询部门和措施
      */
    default_1.prototype.queryDepartmentMeasureSet = function (data) {
        return http.post("./api/indexSystem/queryDepartment_MeasureSet", data);
    };
    /**
     *
     * @param data 教师删除分配案例日志
     */
    default_1.prototype.removeExperiment = function (data) {
        return http.post("./api/experiment/removeExperiment", data);
    };
    /**
     *
     * @param data 教师分配案例日志
     */
    default_1.prototype.queryExperient = function (data) {
        return http.post("./api/experiment/queryExperiment", data);
    };
    /**
     *
     * @param data 查询自定义案例
     */
    default_1.prototype.searchIntelligentExp = function (data) {
        return http.post("./api/intelligentExperiment/searchIntelligentExp", data);
    };
    /**
     *
     * @param data 根据教师code查询所有班级学生
     */
    default_1.prototype.queryClassMemberByTeacherCode = function (data) {
        return http.post("./classMember/queryClassMemberByTeacherCode", data);
    };
    /**
    *
    * @param data 批量创建修改措施指标
    */
    default_1.prototype.batchMergeMeasureIndex = function (data) {
        return http.post("./api/indexSystem/batchMergeMeasureIndex", data);
    };
    /**
    *
    * @param data 查询措施指标
    */
    default_1.prototype.queryMeasureIndex = function (data) {
        return http.post("./api/indexSystem/queryMeasureIndex", data);
    };
    /**
     *
     * @param data 删除措施指标
     */
    default_1.prototype.delMeasureIndex = function (data) {
        return http.post("./api/indexSystem/delMeasureIndex", data);
    };
    /**
     *
     * @param data 根据措施查询执行调整
     */
    default_1.prototype.queryMeasureSetValue = function (data) {
        return http.post("./api/variableFormula/queryMeasureSetValue", data);
    };
    /**
     * 修改执行调整
     * @param data
     */
    default_1.prototype.updateMeasureSetValue = function (data) {
        return http.post("./api/variableFormula/updateMeasureSetValue", data);
    };
    /**
     *
     * @param data 查询评估等级列表
     */
    default_1.prototype.queryAssessLevelList = function (data) {
        return http.post("./api/assessSystem/queryAssessLevelList", data);
    };
    /**
     *
     * @param data 创建修改评估等级
     */
    default_1.prototype.mergeAssessLevel = function (data) {
        return http.post("./api/assessSystem/mergeAssessLevel", data);
    };
    /**
     *
     * @param data 批量修改评估等级
     */
    default_1.prototype.batchUpdateAssessLevelInfo = function (data) {
        return http.post("./api/assessSystem/batchUpdateAssessLevelInfo", data);
    };
    /**
     *
     * @param data  查询评估指标列表
     */
    default_1.prototype.queryAssessIndexList = function (data) {
        return http.post("./api/assessSystem/queryAssessIndexList", data);
    };
    /**
     *
     * @param data  批量修改评估指标
     */
    default_1.prototype.batchMergeAssessIndexList = function (data) {
        return http.post("./api/assessSystem/batchMergeAssessIndexList", data);
    };
    /**
     *
     * @param data 修改评估指标
     */
    default_1.prototype.mergeAssessIndex = function (data) {
        return http.post("./api/assessSystem/mergeAssessIndex", data);
    };
    /**
     * 创建指标变化公式
     */
    default_1.prototype.mergeIndexChange = function (data) {
        return http.post("./api/variableFormula/mergeIndexChange", data);
    };
    /**
     *
     * @param data 删除评估等级
     */
    default_1.prototype.delAssessLevel = function (data) {
        return http.post("./api/assessSystem/delAssessLevel", data);
    };
    /**
     * 查询执行结果公式
     */
    default_1.prototype.queryExecuteResult = function (data) {
        return http.post("./api/variableFormula/queryExecuteResult", data);
    };
    /**
     * 创建执行结果公式
     * @param data
     */
    default_1.prototype.mergeExecuteResult = function (data) {
        return http.post("./api/variableFormula/mergeExecuteResult", data);
    };
    /**
     * 创建结果说明公式
     * @param data
     */
    default_1.prototype.mergeExecuteResultFormula = function (data) {
        return http.post("./api/variableFormula/mergeExecuteResultFormula", data);
    };
    default_1.prototype.batchDelExecuteResultFormula = function (data) {
        return http.post("./api/variableFormula/batchDelExecuteResultFormula", data);
    };
    /**
     * 查询指标措施
     * @param data
     */
    default_1.prototype.queryIndexData = function (data) {
        return http.post("./api/measureTrigger/queryIndexData", data);
    };
    /**
     * 复制案例
     * @param data
     */
    default_1.prototype.copyIntelligentExp = function (data) {
        return http.post("./api/intelligentExp/copyIntelligentExp", data);
    };
    /**
     * 上传事件时间触发图片
     * @param data FormData
     */
    default_1.prototype.mergeTimeTriggerPath = function (data) {
        return http.post("./api/measureTrigger/mergeTimeTriggerPath", data);
    };
    // 保存时间触发事件
    default_1.prototype.mergeTimeTrigger = function (data) {
        return http.post("./api/measureTrigger/mergeTimeTrigger", data);
    };
    /**
   * 查询时间触发事件列表
   * @param data
   */
    default_1.prototype.queryTimeTriggerList = function (data) {
        return http.post("./api/measureTrigger/queryTimeTriggerList", data);
    };
    /**
     * 查询措施触发事件列表
     * @param data
     */
    default_1.prototype.queryMeasureTriggerList = function (data) {
        return http.post("./api/measureTrigger/queryMeasureTriggerList", data);
    };
    /**
     * 查询指标触发事件列表
     * @param data
     */
    default_1.prototype.queryIndexTriggerList = function (data) {
        return http.post("./api/measureTrigger/queryIndexTriggerList", data);
    };
    /**
   * 查询指标事件详情
   * @param data
   */
    default_1.prototype.queryIndexTrigger = function (data) {
        return http.post("./api/measureTrigger/queryIndexTrigger", data);
    };
    /**
     * 删除措施
     */
    default_1.prototype.delMeasureTrigger = function (data) {
        return http.post("./api/measureTrigger/delMeasureTrigger", data);
    };
    default_1.prototype.delTimeTrigger = function (data) {
        return http.post("./api/measureTrigger/delTimeTrigger", data);
    };
    default_1.prototype.delIndexTrigger = function (data) {
        return http.post("./api/measureTrigger/delIndexTrigger", data);
    };
    // 删除地区数据
    default_1.prototype.delRegionalData = function (data) {
        return http.post("./api/intelligentExp/delRegionalData", data);
    };
    // 删除评估纬度
    default_1.prototype.delAssessmentDimensions = function (data) {
        return http.post("./api/intelligentExp/delAssessmentDimensions", data);
    };
    /**
     * 查询时间事件详情
     * @param data
     */
    default_1.prototype.queryTimeTrigger = function (data) {
        return http.post("./api/measureTrigger/queryTimeTrigger", data);
    };
    /**
     * 上传事件措施触发图片
     * @param data FormData
     */
    default_1.prototype.mergeMeasureTriggerPath = function (data) {
        return http.post("./api/measureTrigger/mergeMeasureTriggerPath", data);
    };
    /**
     * 保存措施事件
     * @param data
     */
    default_1.prototype.mergeMeasureTrigger = function (data) {
        return http.post("./api/measureTrigger/mergeMeasureTrigger", data);
    };
    /**
     * 保存指标事件
     * @param data FormData
     */
    default_1.prototype.mergeIndexTrigger = function (data) {
        return http.post("./api/measureTrigger/mergeIndexTrigger", data);
    };
    /**
     * 上传事件指标触发图片
     * @param data
     */
    default_1.prototype.mergeIndexTriggerPath = function (data) {
        return http.post("./api/measureTrigger/mergeIndexTriggerPath", data);
    };
    /**
     * 查询措施事件详情
     * @param data
     */
    default_1.prototype.queryMeasureTrigger = function (data) {
        return http.post("./api/measureTrigger/queryMeasureTrigger", data);
    };
    /**
     * 删除案例
     * @param data
     */
    default_1.prototype.delIntelligentExp = function (data) {
        return http.post("./api/intelligentExp/delIntelligentExp", data);
    };
    /**
     * 分享
     * @param data
     */
    default_1.prototype.shareIntelligentExp = function (data) {
        return http.post("./api/intelligentExp/shareIntelligentExp", data);
    };
    /**
     * 学生端查询首页实验进度(要更换)
     * @param data
     */
    default_1.prototype.queryExperimentMemberList = function (data) {
        return http.post("./api/intelligentExperimentMember/queryExperimentMemberList", data);
    };
    /**
     * 实验管理查询实验列表
     * @param data
     */
    default_1.prototype.queryIntelligentExpList = function (data) {
        return http.post("./api/intelligentExperiment/queryIntelligentExpList", data);
    };
    /**
     * 教师端分配实验
     * @param data
    */
    default_1.prototype.createIntelligentExperiment = function (data) {
        return http.post("./api/intelligentExperiment/createIntelligentExperiment", data);
    };
    /**
   * 查询分配日志
   * @param data
  */
    default_1.prototype.queryAllocationLog = function (data) {
        return http.post("./api/intelligentExperiment/queryAllocationLog", data);
    };
    /**
  * 学生查询部门
  * @param data FormData
  */
    default_1.prototype.queryMapDepartment = function (data) {
        return http.post("./api/stuIntelligentOperation/queryMapDepartment", data);
    };
    /**
     *  查询部门-措施类别以及措施
     * @param data
     */
    default_1.prototype.queryMeasure = function (data) {
        return http.post("./api/stuIntelligentOperation/queryMeasure", data);
    };
    /**
     *  学生实训 修改是否为第一次进入实训
     * @param data
     */
    default_1.prototype.updateFirstEntry = function (data) {
        return http.post("./api/stuIntelligentOperation/updateFirstEntry", data);
    };
    /**
     *  学生实训 查询指标
     * @param data
     */
    default_1.prototype.queryIndex = function (data) {
        return http.post("./api/stuIntelligentOperation/queryIndex", data);
    };
    /**
     *  学生实训 实施指标
     * @param data
     */
    default_1.prototype.implementMeasure = function (data) {
        return http.post("./api/stuIntelligentOperation/implementMeasure", data);
    };
    /**
     *  学生实训 实施指标公式
     * @param data
     */
    default_1.prototype.queryVariableFormula = function (data) {
        return http.post("./api/stuIntelligentOperation/queryVariableFormula", data);
    };
    /**
     * 确认实施指标
     * @param data
     */
    default_1.prototype.affirmImplementMeasure = function (data) {
        return http.post("./api/stuIntelligentOperation/affirmImplementMeasure", data);
    };
    // /**
    //  * 查询数据检测
    //  * @param data
    //  */
    // queryMonitorIndex(data: UpdateFirstEntryRequest) {
    //   return http.post("./api/stuIntelligentOperation/queryMonitorIndex", data);
    // }
    /**
     * 学生实训 学生选择操作性事件选项
     * @param data
     */
    default_1.prototype.chooseOption = function (data) {
        return http.post('./api/stuIntelligentOperation/chooseOption', data);
    };
    /**
     * 数据检测（折线图数据）
     * @param data
     */
    default_1.prototype.monitorIndex = function (data) {
        return http.post('./api/stuIntelligentOperation/monitorIndex', data);
    };
    /**
     * 数据检测（查询反馈、事件、措施）
     * @param data
     */
    default_1.prototype.monitorMeasureRecord = function (data) {
        return http.post('./api/stuIntelligentOperation/monitorMeasureRecord', data);
    };
    /**
     * 数据检测（查询指标）
     * @param data
     */
    default_1.prototype.queryMonitorIndex = function (data) {
        return http.post('./api/stuIntelligentOperation/queryMonitorIndex', data);
    };
    /**
     *  教师端报告一级页面
     * @param data
     */
    default_1.prototype.queryFirstLevelReport = function (data) {
        return http.post("./api/intelligentExperiment/queryFirstLevelReport", data);
    };
    /**
     *  教师端报告二级页面
     * @param data
     */
    default_1.prototype.querySecondLevelReport = function (data) {
        return http.post("./api/intelligentExperiment/querySecondLevelReport", data);
    };
    /**
     *  学生评估结果
     * @param data
     */
    default_1.prototype.queryAssessResult = function (data) {
        return http.post("./api/stuIntelligentOperation/assessResult", data);
    };
    /**
     * 学生批量读取反馈
     * @param data
     */
    default_1.prototype.batchRead = function (ids) {
        return http.post('./api/stuIntelligentOperation/batchRead', { ids: JSON.stringify(ids) });
    };
    default_1.prototype.getAssessResult = function (data) {
        return http.post("./api/stuIntelligentOperation/getAssessResult", data);
    };
    default_1.prototype.queryPolicyAnalysis = function () {
        /**
          *  查询演练流程
          *
        */
        return http.post("./api/intelligentExperimentMember/queryPolicyAnalysis");
    };
    default_1.prototype.getCurrentTimeMillis = function () {
        /**
          *  获取系统当前时间戳
        */
        return http.post("./api/intelligentExperiment/getCurrentTimeMillis");
    };
    default_1.prototype.exportIntelligentReport = function (data) {
        /**
          *  二级报告页面下载报告
        */
        return http.post("./api/exportIntelligentReport/exportIntelligentReport", data);
    };
    default_1.prototype.queryPolicyAnalysisList = function (data) {
        /**
          * 学生端查看报告报告列表
        */
        return http.post("./api/intelligentExperimentMember/queryPolicyAnalysisList", data);
    };
    default_1.prototype.exportIntelligentExpScore = function (data) {
        /**
          * 一级报告页面下载报告
        */
        return http.post("./api/exportExcel/exportIntelligentExpScore", data);
    };
    /**
      * 二级报告管理页面筛选
    */
    default_1.prototype.filtrateIntelligentExperiment = function (data) {
        return http.post("./api/intelligentExperiment/filtrateIntelligentExperiment", data);
    };
    default_1.prototype.exportIntelligentReportToZIp = function (data) {
        /**
          * 二级报告管理页面批量下载报告
        */
        return http.post("./api/exportExperimentReport/exportIntelligentReportToZIp", data);
    };
    /**
      * 查询个人全部通知
    */
    default_1.prototype.intelligentNotification = function (data) {
        return http.post("./intelligentNotification/listAll", data);
    };
    default_1.prototype.updateNotificationRead = function (data) {
        //标记通知为已读
        return http.post("./intelligentNotification/updateNotificationRead", data);
    };
    //删除所有的通知消息
    default_1.prototype.delAllNotification = function () {
        return http.post("./intelligentNotification/delAll");
    };
    default_1.prototype.delAllocationLog = function (data) {
        //报告管理删除日志
        return http.post("./api/intelligentExperiment/delAllocationLog", data);
    };
    default_1.prototype.getEndExperimentCount = function () {
        // 查询已完成实验的个数
        return http.post("./api/intelligentExperimentMember/getEndExperimentCount");
    };
    default_1.prototype.updatePublish = function (data) {
        // 修改实验的发布状态
        return http.post("./api/intelligentExp/updatePublish", data);
    };
    return default_1;
}());
export default default_1;
;
